import { trackPromise } from "react-promise-tracker";
import { toast } from "react-toastify";
import useInspectionClient from "./useInspectionClient";

type ActionMethod = "post" | "put" | "delete";

export type ApiResponse = {
  id: number | string;
};

export const useSubmitForm = <T>(
  endpoint: string,
  callback: (response: ApiResponse) => void,
  action: ActionMethod = "post",
  validation?: (data: T) => boolean,
) => {
  const client = useInspectionClient();
  const request = client.api(endpoint);

  const submit = async (data: T) => {
    // let okToSubmit = true;
      let response;

    // // If validation function provided, call it.
    // if (validation) {
    //   okToSubmit = validation(data);
    // }

    // if (okToSubmit) {
    try {
      // Send request to API.
      switch (action) {
        case "post":
          response = await trackPromise(request.post(data as FormData));
          break;
        case "put":
          response = await trackPromise(request.put(data as FormData));
          break;
        case "delete":
          response = await trackPromise(request.delete(data ?? {}));
          break;
      }

      // Only call callback if response is successful
      if (response && response.ok) {
        callback(response.data);
      } else {
        // Handle case where response exists but is not ok
        const errorMessage = response?.error || "Request failed";
        toast.error(errorMessage, { autoClose: 5000 });
        console.error("Form submission failed:", response);
      }
    } catch (error: any) {
      // Extract error message from various possible error formats
      let errorMessage = "An error occurred while submitting the form";
      
      if (error.message) {
        errorMessage = error.message;
      } else if (error.error) {
        errorMessage = error.error;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      }
      
      toast.error(errorMessage, { autoClose: 5000 });
      console.error("Form submission error:", error);
      
      // Re-throw the error so the calling code knows the submission failed
      throw error;
    }
    // }
  };

  return submit;
};

export default useSubmitForm;
